import Shield from "../../assets/svg/Shield.svg";
import React, { useEffect, useState } from "react";

export default function PermissionDenied() {
  const [countdown, setCountdown] = useState(10);
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          window.location.replace(
            `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
          );
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="installation-container">
      <header style={{ padding: "20px" }} className="header">
        <div className="flex items-center gap-2">
          <a href="/salesforce/setup" className="magic-logo">
            <img
              src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
              alt="logo"
              style={{ height: "24px", width: "143.3px" }}
            ></img>
          </a>
        </div>
      </header>
      <div className="installation-container">
        <header style={{ padding: "20px" }} className="header">
          <div className="flex items-center gap-2">
            <a href="/salesforce/setup" className="magic-logo">
              <img
                src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
                alt="logo"
                style={{ height: "24px", width: "143.3px" }}
              ></img>
            </a>
          </div>
        </header>
        <main className="main-content-cancel">
          <div className="icon-container">
            <img src={Shield} alt="Shield Icon" className="icon-sms" />
          </div>
          <div className="installation-text">
            <h1 className="title">
              Your account does not have the necessary <br /> permissions to upgrade
              this package
            </h1>
          </div>
          <div
            className="workspace-redirect"
            style={{ marginBottom: "20px", marginTop: "20px" }}
          >
            Redirecting to workspace in{" "}
            <span className="timer">{countdown} seconds</span>
          </div>
        </main>
      </div>
    </div>
  );
}
